export const PAGE_NAMES = {
    Bidding: 'MyTradera_Bidding',
    Overview: 'MyTradera',
    MyTraderaLeaveFeedback: 'MyTradera_LeaveFeedback',
    MyTraderaMyFeedback: 'MyTradera_MyFeedback',
    SellerList: 'MyTradera_SellerList',
    SellerSold: 'MyTradera_SoldItems',
    SellerListings: 'MyTradera_Listings',
    BuyerPurchases: 'MyTradera_Purchases',
    SavedSearches: 'MyTradera_SavedSearches',
    Settings: 'MyTradera_Settings',
    SettingsAccount: 'MyTradera_SettingsAccount',
    SettingsEmail: 'MyTradera_SettingsEmail',
    SettingsNotifications: 'MyTradera_SettingsNotifications',
    SettingsSeller: 'MyTradera_SettingsSeller',
    SettingsSecurity: 'MyTradera_SettingsSecurity',
    SettingsPayouts: 'MyTradera_SettingsPayouts',
    Payouts: 'MyTradera_Payouts',
    Accounting: 'MyTradera_Accounting',
    Invoices: 'MyTradera_Invoices',
    WishList: 'MyTradera_WishList',
    Picklist: 'MyTradera_PickList'
} as const;
